import appPrivateBusRequest from "../../views/appSettings/privatebusrequest.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("privatebusrequest", {
    url: "private-bus-request/:id",
    parent: "app",
    views: {
      view: {
        template: appPrivateBusRequest,
      },
    },
    reloadOnSearch: false,
    data: { title: "PrivateBusRequest" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/privateBusRequest/privateBusRequest.urls.js